import { aiApiClient } from "@src/api/ai-api";
import { knowledgeKeys } from "@src/api/queryKeys";
import { useQuery } from "@tanstack/react-query";

const getKnowledgeCategories = async (source?: string): Promise<string[]> => {
  const query = source ? `?source=${encodeURIComponent(source)}` : "";
  const { data } = await aiApiClient.get<{ categories: string[] }>(
    `/knowledge/documents/categories${query}`
  );

  return data.categories;
};

export const useGetKnowledgeCategories = (source?: string) =>
  useQuery({
    queryKey: knowledgeKeys.categories(source),
    queryFn: async () => getKnowledgeCategories(source),
  });
